import { colors } from "@mui/material";

export const whyMperito = [
    {
        color: colors.lightBlue[500],
        title: 'Zero Technical Knowledge Required',
        subtitle: 'Our team handles all technical integration aspects, allowing you to join ONDC without any coding or development resources.',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 18l6-6-6-6M8 6l-6 6 6 6" />
            </svg>
        ),
    },
    {
        color: colors.lightBlue[500],
        title: 'Complete Catalogue Digitisation',
        subtitle: 'We transform your product information into ONDC-compliant digital listings with professional formatting and optimisation.',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M8.5 11.5L4 17h16l-5.5-7.5-4.5 6z"
                />
                <circle cx="8" cy="8" r="1.5" fill="currentColor" />
            </svg>
        ),
    },
    {
        color: colors.lightBlue[500],
        title: 'Seamless Inventory & Order Management',
        subtitle: 'Real-time inventory sync across all buyer apps prevents overselling, while our centralised order management streamlines fulfilment.',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 4v5h.582M20 20v-5h-.581M4.582 9A8 8 0 0112 4a8 8 0 017.418 5M19.418 15A8 8 0 0112 20a8 8 0 01-7.418-5"
                />
                <line x1="12" y1="10" x2="12" y2="14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                <circle cx="12" cy="16.5" r="1" fill="currentColor" />
            </svg>
        ),
    },
    {
        color: colors.lightBlue[500],
        title: 'Logistics & Payment Integration',
        subtitle: 'We connect your business to ONDC-approved logistics partners and payment gateways for smooth end-to-end operations.',
        icon: (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                width="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 7H16V17H3V7Z"
                />
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16 10H20L21.5 12V17H16V10Z"
                />
                <circle cx="5.5" cy="18.5" r="1.5" fill="currentColor" />
                <circle cx="18.5" cy="18.5" r="1.5" fill="currentColor" />
            </svg>
        ),
    },
];

export default whyMperito;